import ComingSoon from "../../components/ComingSoon/ComingSoon";

const ParentHome = () => {
  return (
    <>
      <ComingSoon />
    </>
  );
};

export default ParentHome;
